/**
 * What Configuración checks before saving, and how it tells a changed card from
 * a saved one. The database refuses a bad value too; checking here names the
 * problem in the card before anything is sent.
 */

export const isBlank = (value) => String(value ?? '').trim() === '';

/** A whole number from min to max, typed or stored. */
export const inRange = (value, [min, max]) => {
  const number = Number(value);
  return !isBlank(value) && Number.isInteger(number) && number >= min && number <= max;
};

/**
 * An alias (6 to 20 letters, digits, dots or hyphens) or a CBU/CVU of 22
 * digits: the rule the database applies to therapists.payment_alias (0062).
 */
export const isPaymentAlias = (value) => /^[0-9]{22}$/.test(value) || /^[a-z0-9.-]{6,20}$/i.test(value);

/**
 * Whether a card's fields are as saved. Each field reads as text, so 45 saved
 * and "45" typed are the same, and so are null and an empty field.
 */
export const sameFields = (a, b) => Object.keys({ ...a, ...b })
  .every((field) => String(a[field] ?? '') === String(b[field] ?? ''));

/** A week of hours as set_my_availability takes it (0044). */
export const weekPayload = (blocks) => blocks.map((block) => ({
  weekday: Number(block.weekday),
  starts_at: String(block.starts_at).slice(0, 5),
  ends_at: String(block.ends_at).slice(0, 5),
  location_id: block.location_id || null,
  allows_online: Boolean(block.allows_online),
  requires_approval: Boolean(block.requires_approval),
}));

/**
 * A week compared by what would be saved: not the editor's keys, the order of
 * the blocks, or the seconds the database adds to a time.
 */
export const weekSignature = (blocks) => weekPayload(blocks ?? [])
  .map((block) => JSON.stringify(block))
  .sort()
  .join('|');
